import React, { useEffect, useState, useCallback, useRef } from 'react'
import Menu from './Menu.js';
import Homepage from './Homepage.js';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate} from 'react-router-dom';
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import { makeStyles, createStyles, withStyles, Theme } from '@material-ui/core/styles';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import CheckIcon from '@mui/icons-material/Check';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import TextField from '@mui/material/TextField';
import Popover from '@mui/material/Popover';
import { styled } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useAuth0 } from "@auth0/auth0-react";
import Chip from '@mui/material/Chip';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';

import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';

import SettingsIcon from '@mui/icons-material/Settings';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar, Rectangle, ComposedChart, Scatter, LabelList } from 'recharts';


const App = () => {

  const navigate = useNavigate();
  const handleOnClick = (url) => window.open(url, "_blank", "noreferrer");

  const [gridRef, setGridRef] = useState(null);

  const { logout, isAuthenticated } = useAuth0();
  const { loginWithRedirect } = useAuth0();

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      foto_field: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        '&:hover': {
          cursor: 'pointer',
        },
      },
      bulk_item: {
        width: '120px',
        margin: '0px 0px 10px 10px',
        textAlign: 'center',
        height: '58px',
        paddingTop: '5px',
        color: '#555e68',
        '&:hover': {
          cursor: 'pointer',
          color: '#9452c0',
          border: '1px solid #9452c0'
        },
      },
      bulk_icon: {
        color: '#000'
      },
      bulk_icon_inactive: {
        color: '#97999c'
      },
      basic_link: {
        '&:hover': {
          cursor: 'pointer',
          textDecoration: 'underline'
        }
      }
    }),
  );


  const [data, setData] = React.useState([]);

  const requestOptions = {
          method: 'GET',
          headers: { 'Authentication': 'Basic bGxveWQ6aG9ua2JhbA==' }
      };

    useEffect(() => {
      const getData = async () => {
        const res = await fetch("/api/get_delivery_rate", requestOptions);
        //console.log(res);
        const response = await res.json();
        setData(response);
      };
      getData();
    }, []);



    const [dataCountries, setDataCountries] = React.useState([]);

      useEffect(() => {
        const getDataCountries = async () => {
          const res = await fetch("/api/get_delivery_rate_countries", requestOptions);
          //console.log(res);
          const response = await res.json();
          setDataCountries(response);
        };
        getDataCountries();
      }, []);


    const [dataPackages, setDataPackages] = React.useState([]);

      useEffect(() => {
        const getDataPackages = async () => {
          const res = await fetch("/api/get_delivery_rate_package", requestOptions);
          //console.log(res);
          const response = await res.json();
          setDataPackages(response);
        };
        getDataPackages();
      }, []);


      const [myMarketplace, setMyMarketplace] = React.useState('Decathlon');

      const [countryTimescope, setCountryTimescope] = useState('Delivery on time % (last month)');


  if (isAuthenticated) {

  return (

    <div>

    <Grid container>

      <Grid item xs="auto">

        <Menu navigate={navigate} page={'dashboard'}/>

      </Grid>

      <Grid xs>

    <div>

    <div style={{marginTop: '55px', padding: '10px 20px 10px 20px'}}>



    <Grid container
    width='100%'
     sx={{
        justifyContent: "flex-start",
        alignItems: "flex-start",
      }}>

   <Grid item>

   <Grid container>
   <Grid item>
     <Button onClick={() => setMyMarketplace('Decathlon')} style={{marginLeft: 10}} variant={myMarketplace === "Decathlon" ? "contained" : "outlined"} >Decathlon</Button>
   </Grid>

   <Grid item>
     <Button onClick={() => setMyMarketplace('Amazon')} style={{marginLeft: 10}} variant={myMarketplace === "Amazon" ? "contained" : "outlined"} >Amazon</Button>
   </Grid>
   </Grid>


    <h4>Delivery on time %</h4>

         <ComposedChart
           width={700}
           height={300}
           data={data.filter((item) => item.Marketplace === myMarketplace)}
           barCategoryGap="20%"
           margin={{
             top: 5,
             right: 30,
             left: 20,
             bottom: 5,
           }}
         >
           <CartesianGrid strokeDasharray="3 3" />
           <XAxis dataKey="period"
           fontSize="80%"
           />
           <YAxis
             dataKey="Delivery on time %"
              tickFormatter={tick => `${tick}%`}
              domain={[0, 100]}
              orientation="left"
              allowDataOverflow
              fontSize="80%"
            />
           <Legend />
           <Bar dataKey="Delivery on time %" fill="#1c75d0" background={{ fill: '#eee' }} isAnimationActive={false} />
           <Scatter fill="none" isAnimationActive={false}>
            <LabelList dataKey="# orders on time" position="bottom" fill="white" fontSize="70%"/>
            <LabelList dataKey="# orders delayed" position="top" fill="gray" fontSize="70%"/>
           </Scatter>
         </ComposedChart>
  </Grid>

  <Grid item>

  <Grid container>
  <Grid item>
    <Button onClick={() => setCountryTimescope('Delivery on time % (last month)')} style={{marginLeft: 10}} variant={countryTimescope === "Delivery on time % (last month)" ? "contained" : "outlined"} >Last month</Button>
  </Grid>

  <Grid item>
    <Button onClick={() => setCountryTimescope('Delivery on time % (current month)')} style={{marginLeft: 10}} variant={countryTimescope === "Delivery on time % (current month)" ? "contained" : "outlined"} >Current month</Button>
  </Grid>

  <Grid item>
    <Button onClick={() => setCountryTimescope('Delivery on time %')} style={{marginLeft: 10}} variant={countryTimescope === "Delivery on time %" ? "contained" : "outlined"} >All time</Button>
  </Grid>
  </Grid>

        <h4>Countries</h4>

         <ComposedChart
                   width={850}
                   height={300}
                   data={dataCountries.filter((item) => item.Marketplace === myMarketplace)}
                   barCategoryGap="20%"
                   margin={{
                     top: 5,
                     right: 30,
                     left: 20,
                     bottom: 5,
                   }}
                 >
                   <CartesianGrid vertical={false} strokeDasharray="3 3" />
                   <XAxis dataKey="Country"
                    fontSize="80%"
                   />
                   <YAxis
                      dataKey={countryTimescope}
                      tickFormatter={tick => `${tick}%`}
                      domain={[0, 100]}
                      orientation="left"
                      allowDataOverflow
                      fontSize="80%"
                    />
                   <Legend />
                   <Bar dataKey={countryTimescope} fill="#1c75d0" background={{ fill: '#eee' }} isAnimationActive={false} />
                   <Scatter fill="none" isAnimationActive={false}>
                    <LabelList dataKey={countryTimescope === 'Delivery on time % (last month)' ? "# orders on time (last month)" : (countryTimescope === 'Delivery on time % (current month)' ? "# orders on time (current month)" : "# orders on time")} position="bottom" fill="#eee" fontSize="70%"/>
                    <LabelList dataKey={countryTimescope === 'Delivery on time % (last month)' ? "# orders delayed (last month)" : (countryTimescope === 'Delivery on time % (current month)' ? "# orders delayed (current month)" : "# orders delayed")} position="top" fill="gray" fontSize="70%"/>
                   </Scatter>
                 </ComposedChart>

     </Grid>

     <Grid item>
           <h4>Package type</h4>

                <LineChart
                  width={700}
                  height={300}
                  data={dataPackages.filter((item) => item.Marketplace === myMarketplace)}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="period"
                  fontSize="80%"
                  />
                  <YAxis
                     tickFormatter={tick => `${tick}%`}
                     domain={[0, 100]}
                     fontSize="80%"
                   />
                  <Legend />
                  <Line type="monotone" dataKey="PostNL Brievenbus Buitenland (6942)" stroke="#428917" strokeWidth={1} fill="#428917" r={4} isAnimationActive={false}/>
                  <Line type="monotone" dataKey="PostNL International Packet (6550)" stroke="#1c75d0" strokeWidth={1} fill="#1c75d0" r={4} isAnimationActive={false}/>
                  <Line type="monotone" dataKey="DPD Home" stroke="#ed6c02" strokeWidth={1} fill="#ed6c02" r={4} isAnimationActive={false}/>
                </LineChart>

        </Grid>

        <Grid item>
          <br />
        </Grid>

      </Grid>


      <p />
      <br />
      <p />


      </div>

      </div>

      </Grid>

    </Grid>

      </div>
  )
}
else {
  return (
      <Homepage />
)
}
}

export default () => <App />
